/**
 * @generated SignedSource<<5306d96bd0dc5121d913a0eab0f8481a>>
 * @relayHash 827c18dad82bd22a8c9f86aaaec60610
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e21c1817fff75009deaef7a337249a2f94bfeb2f72a0b4e95726737ef6f7ff0b

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HelpCenterMediaConfigOperationType = "BANNER_UPLOAD" | "LOGO_UPLOAD" | "READ" | "%future added value";
export type hubHomeContentWrapperQuery$variables = {
  cloudId: string;
  hubAri: string;
  hubEditMode: boolean;
  operationType?: HelpCenterMediaConfigOperationType | null | undefined;
  pageAri: string;
};
export type hubHomeContentWrapperQuery$data = {
  readonly helpCenter: {
    readonly " $fragmentSpreads": FragmentRefs<"hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference" | "hubHomeContent_AtlassianHubHome_HubInfo">;
  } | null | undefined;
  readonly me: {
    readonly user: {
      readonly accountId: string;
    } | null | undefined;
  };
  readonly " $fragmentSpreads": FragmentRefs<"hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference">;
};
export type hubHomeContentWrapperQuery = {
  response: hubHomeContentWrapperQuery$data;
  variables: hubHomeContentWrapperQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hubAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hubEditMode"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "operationType"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageAri"
},
v5 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v6 = [
  {
    "kind": "Variable",
    "name": "pageAri",
    "variableName": "pageAri"
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v8 = {
  "kind": "Variable",
  "name": "operationType",
  "variableName": "operationType"
},
v9 = [
  {
    "kind": "ScalarField",
    "name": "asapIssuer"
  },
  {
    "kind": "ScalarField",
    "name": "mediaCollectionName"
  },
  {
    "kind": "ScalarField",
    "name": "mediaToken"
  },
  {
    "kind": "ScalarField",
    "name": "mediaUrl"
  }
],
v10 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v11 = {
  "kind": "ScalarField",
  "name": "type"
},
v12 = [
  {
    "kind": "ScalarField",
    "name": "default"
  }
],
v13 = {
  "concreteType": "HelpCenterNavigationBar",
  "kind": "LinkedField",
  "name": "navigationBar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "backgroundColor"
    },
    {
      "kind": "ScalarField",
      "name": "borderColor"
    },
    {
      "kind": "ScalarField",
      "name": "borderType"
    },
    {
      "kind": "ScalarField",
      "name": "cornerRadius"
    },
    {
      "kind": "ScalarField",
      "name": "padding"
    },
    {
      "kind": "ScalarField",
      "name": "positionType"
    },
    {
      "kind": "ScalarField",
      "name": "textColor"
    }
  ]
},
v14 = {
  "kind": "ScalarField",
  "name": "id"
},
v15 = {
  "concreteType": "HelpCenterPageName",
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": (v12/*: any*/)
},
v16 = [
  (v14/*: any*/),
  (v15/*: any*/),
  {
    "concreteType": "HelpCenterPageDescription",
    "kind": "LinkedField",
    "name": "description",
    "plural": false,
    "selections": (v12/*: any*/)
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "hubHomeContentWrapperQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v6/*: any*/),
            "kind": "FragmentSpread",
            "name": "hubHomeContent_AtlassianHubHome_HubInfo"
          },
          {
            "args": (v6/*: any*/),
            "kind": "FragmentSpread",
            "name": "hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference"
          }
        ]
      },
      {
        "kind": "FragmentSpread",
        "name": "hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference"
      },
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v7/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "hubHomeContentWrapperQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "alias": "pageMediaConfig",
            "args": [
              {
                "kind": "Variable",
                "name": "ari",
                "variableName": "pageAri"
              },
              (v8/*: any*/)
            ],
            "concreteType": "HelpCenterMediaConfig",
            "kind": "LinkedField",
            "name": "hubMediaConfig",
            "plural": false,
            "selections": (v9/*: any*/)
          },
          {
            "args": [
              {
                "kind": "Variable",
                "name": "helpCenterAri",
                "variableName": "hubAri"
              }
            ],
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v11/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "hoistedProjectKey"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "slug"
                  },
                  {
                    "concreteType": "HelpCenterName",
                    "kind": "LinkedField",
                    "name": "name",
                    "plural": false,
                    "selections": (v12/*: any*/)
                  },
                  {
                    "concreteType": "HelpCenterBranding",
                    "kind": "LinkedField",
                    "name": "helpCenterBranding",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/)
                    ]
                  },
                  {
                    "alias": "allPages",
                    "concreteType": "HelpCenterPage",
                    "kind": "LinkedField",
                    "name": "pages",
                    "plural": true,
                    "selections": (v16/*: any*/)
                  },
                  {
                    "alias": "customPages",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "ids": [],
                          "type": "CUSTOM"
                        }
                      }
                    ],
                    "concreteType": "HelpCenterPage",
                    "kind": "LinkedField",
                    "name": "pages",
                    "plural": true,
                    "selections": (v16/*: any*/),
                    "storageKey": "pages(filter:{\"ids\":[],\"type\":\"CUSTOM\"})"
                  },
                  (v11/*: any*/),
                  {
                    "alias": "currentPage",
                    "args": [
                      {
                        "fields": [
                          {
                            "items": [
                              {
                                "kind": "Variable",
                                "name": "ids.0",
                                "variableName": "pageAri"
                              }
                            ],
                            "kind": "ListValue",
                            "name": "ids"
                          }
                        ],
                        "kind": "ObjectValue",
                        "name": "filter"
                      }
                    ],
                    "concreteType": "HelpCenterPage",
                    "kind": "LinkedField",
                    "name": "pages",
                    "plural": true,
                    "selections": [
                      (v14/*: any*/),
                      (v15/*: any*/),
                      {
                        "concreteType": "HelpCenterPageLayout",
                        "kind": "LinkedField",
                        "name": "pageLayout",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "HelpCenterLayoutAdf",
                            "kind": "LinkedField",
                            "name": "layoutAdf",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "HelpCenterLayoutAdfContentConnection",
                                "kind": "LinkedField",
                                "name": "content",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "HelpCenterLayoutAdfContentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "HelpCenterLayoutAdfContent",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "content"
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "concreteType": "HelpCenterBranding",
                    "kind": "LinkedField",
                    "name": "helpCenterBranding",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "HelpCenterLogo",
                        "kind": "LinkedField",
                        "name": "logo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "fileId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "url"
                          }
                        ]
                      },
                      {
                        "concreteType": "HelpCenterBrandingColors",
                        "kind": "LinkedField",
                        "name": "colors",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "primary"
                          }
                        ]
                      },
                      (v13/*: any*/)
                    ]
                  }
                ],
                "type": "HelpCenter"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "message"
                  }
                ],
                "type": "QueryError"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v14/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          },
          {
            "args": [
              {
                "kind": "Variable",
                "name": "ari",
                "variableName": "hubAri"
              },
              (v8/*: any*/)
            ],
            "concreteType": "HelpCenterMediaConfig",
            "kind": "LinkedField",
            "name": "hubMediaConfig",
            "plural": false,
            "selections": (v9/*: any*/)
          }
        ]
      },
      {
        "condition": "hubEditMode",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              {
                "items": [
                  {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                  }
                ],
                "kind": "ListValue",
                "name": "cloudIds"
              }
            ],
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "cloudUrl"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              (v7/*: any*/),
              (v14/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "e21c1817fff75009deaef7a337249a2f94bfeb2f72a0b4e95726737ef6f7ff0b",
    "metadata": {},
    "name": "hubHomeContentWrapperQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "647b06faa4e451d097f1c1141f02b3ef";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
